/* eslint-disable ember/no-new-mixins */
import Mixin from '@ember/object/mixin';

// FlipMixer mixin is based on the "FlipMove" React component described at:
// https://medium.com/developers-writing/animating-the-unanimatable-1346a5aab3cd
// and available at https://github.com/joshwcomeau/react-flip-move

export default Mixin.create({
  childSelector: '*',
  willRender() {
    this._super(...arguments);
    if (this.element) {
      let positions = [];
      this.element.querySelectorAll(this.childSelector).forEach((element) => {
        positions[element.id] = element.getBoundingClientRect();
      });
      this.set('_childElementPositions', positions);
    }
  },
  didRender() {
    this._super(...arguments);
    if (this.element && this._childElementPositions) {
      this.element.querySelectorAll(this.childSelector).forEach((element) => {
        const newBox = element.getBoundingClientRect();
        const oldBox = this._childElementPositions[element.id];
        if (!oldBox) {
          return;
        }
        const deltaX = oldBox.left - newBox.left;
        const deltaY = oldBox.top - newBox.top;

        if (deltaX || deltaY) {
          requestAnimationFrame(() => {
            element.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
            element.style.transition = 'transform 0s';

            requestAnimationFrame(() => {
              // In order to get the animation to play, we'll need to wait for
              // the 'invert' animation frame to finish, so that its inverted
              // position has propagated to the DOM.
              //
              // Then, we just remove the transform, reverting it to its natural
              // state, and apply a transition so it does so smoothly.
              element.style.transform = '';
              element.style.transition = 'transform 500ms ease-out';
            });
          });
        }
      });
    }
  },
});
